export default {
  fr: {
    points: 'points',
    thanks_to_you: 'Grâce à vous 👏',
  },
  en: {
    points: 'points',
    thanks_to_you: 'Thanks to you 👏',
  },
  'pt-br': {
    points: 'pontos',
    thanks_to_you: 'Graças a você 👏',
  },
  es: {
    points: 'puntos',
    thanks_to_you: 'Gracias a ti 👏',
  },
  de: {
    points: 'Punkte',
    thanks_to_you: 'Dank euch 👏',
  },
} as const
